<lib-button
  [type]="type()"
  [size]="size()"
  [disabled]="disabled()"
  [loading]="loading()"
  [fullWidth]="fullWidth()"
  [leadingIconName]="leadingIconName()"
  [trailingIconName]="dropdownContent.state ? 'chevron-up' : 'chevron-down'"
  [floatUi]="dropdownContent"
  [showTrigger]="NgxFloatUiTriggers.click"
  [placement]="this.alignRight() ? NgxFloatUiPlacements.BOTTOMEND : NgxFloatUiPlacements.BOTTOMSTART"
  [positionFixed]="true"
  [preventOverflow]="true"
  [hideOnScroll]="true"
  (click)="$event.stopPropagation()">
  <ng-content></ng-content>
</lib-button>

<float-ui-content #dropdownContent>
  <div class="dropdown-content">
    @if (clearable() && !disabled() && selectedValue() !== null && selectedValue() !== undefined) {
      <div class="reset-dropdown-item"
           (click)="$event.stopPropagation(); dropdownItemClicked(null); dropdownContent.hide()" i18n>Reset
      </div>
    }
    @for (dropdownItem of dropdownItems(); track $index) {
      @let isItemSelected = dropdownItem.value === selectedValue();
      <div
        class="dropdown-item"
        (click)="$event.stopPropagation(); (!dropdownItem.disabled ? dropdownItemClicked(dropdownItem) : null); (!dropdownItem.disabled ? dropdownContent.hide() : null)"
        [class.disabled]="dropdownItem.disabled"
        [class.selected]="isItemSelected">
        <div class="selected-icon-container">
          @if (isItemSelected) {
            <mat-icon class="selected-icon" [svgIcon]="'check'"></mat-icon>
          }
        </div>
        @if (dropdownItem.statusPillType !== undefined) {
          <lib-general-status-pill [type]="dropdownItem.statusPillType">
            {{ dropdownItem.title }}
          </lib-general-status-pill>
        } @else {
          <div class="dropdown-item-title" [class.align-right]="alignRight()">
            {{ dropdownItem.title }}
          </div>
        }
      </div>
    }
  </div>
</float-ui-content>
